import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import logoMark from '../../assets/images/mc-mark.png';
import SidebarContent from './SidebarContent';

const Sidebar = (props) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light">
            <span className="logo-lg">
              <img src={logoMark} alt="MC" className="brand-mark" />
              <span className="brand-wm">MC&nbsp;Platform</span>
            </span>
            <span className="logo-sm">
              <img src={logoMark} alt="MC" className="brand-mark" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== 'condensed' ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
        {/* close-btn ПОСЛЕДНИМ ребёнком — рисуется поверх SimpleBar-контента (клик не перехватывается) */}
        <button
          type="button"
          className="drawer-close-btn"
          aria-label="Закрыть меню"
          onClick={() => document.body.classList.remove('sidebar-enable')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(mapStatetoProps, {})(withRouter(Sidebar));
